import { useEffect } from "react";

export default function useToScrollatTop() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
}
